import { useEffect, useState } from 'react';
import { ALL_FILTERS } from '../utils/variables';
import { getRandomNumberWithinRange } from '../utils/getters';

export const useFilters = (elements, isInitialRankRandom = false) => {
  const [rank, setRank] = useState(
    isInitialRankRandom ? getRandomNumberWithinRange(0, elements.length - 1) : 0
  );
  const [selectedElement, setSelectedElement] = useState(elements[rank]);
  const isBeginningOfList = () => rank === 0;
  const isEndOfList = () => elements.length - 1 === rank;

  const handleClickBackward = () =>
    isBeginningOfList() ? setRank(elements.length - 1) : setRank(rank - 1);

  const handleClickForward = () =>
    isEndOfList() ? setRank(0) : setRank(rank + 1);

  const isAllFilter = () => selectedElement?.id === ALL_FILTERS.id;

  const isSelectedElement = (element) =>
    selectedElement.contentful_id === element?.contentful_id;

  useEffect(() => {
    setSelectedElement(elements[rank]);
  }, [rank]);

  return {
    rank,
    handleClickBackward,
    handleClickForward,
    selectedElement,
    setRank,
    setSelectedElement,
    isBeginningOfList,
    isEndOfList,
    isAllFilter,
    isSelectedElement
  };
};
